module.exports = __webpack_public_path__ + "static/media/clubs-queen.1c36136e.png";